export const DEFAULT_PAGE = 0;

export const TAB_NEWS = 0;
export const TAB_EVENTS = 1;

export const STREAM_NEWS = 'news';
export const STREAM_EVENTS = 'events';

export const STREAM_PAGE_SIZE = 10;